import { ReactComponent as LogoDark } from './assets/HostalApp/HostalAPPLogoDark.svg';
import { ReactComponent as LogoLight } from './assets/HostalApp/HostalAPPLogoLigth.svg';

// Importa los íconos de Material-UI
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import BusinessIcon from '@mui/icons-material/Business';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentIcon from '@mui/icons-material/Payment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ScheduleIcon from '@mui/icons-material/Schedule';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ImageIcon from '@mui/icons-material/Image';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

let Menuitems = [
  {
    title: 'Inicio',
    icon: HomeIcon, 
    href: '/home',
  },
  {
    title: 'Prospectos',
    icon: PeopleAltIcon,
    href: '/prospectos',
  },
  {
    title: 'Empresas',
    icon: BusinessIcon,
    href: '/empresas',
  },
  {
    title: 'Planes',
    icon: LocalOfferIcon,
    href: '/planes',
  },
  {
    title: 'Suscripciones',
    icon: CreditCardIcon,
    href: '/suscripciones',
  },
  {
    title: 'Pagos',
    icon: PaymentIcon,
    href: '/pagos',
  },
  {
    title: 'Reportes',
    icon: AssessmentIcon,
    href: '/reportes',
  },
  {
    title: 'NPS',
    icon: SentimentSatisfiedAltIcon,
    href: '/nps',
  },
  {
    title: 'Usuarios Globales',
    icon: PersonIcon,
    href: '/usuarios',
  },
  {
    title: 'Notificaciones',
    icon: NotificationsIcon,
    href: '/notificaciones',
  },
  {
    title: 'Apariencia',
    icon: ImageIcon,
    href: '/apariencia',
  },
  {
    title: 'Gestión de Crones',
    icon: ScheduleIcon,
    href: '/crones',
  },
  {
    type: 'separator',
  },
  {
    title: 'Cerrar Sesión',
    icon: LogoutIcon,
    href: '/auth/close',
  },
];

const nameApp = 'Hospedapp - Administración';

const urlEndPoint = process.env.REACT_APP_API;

const DateRevision = [
  { month: 1, digite: 9 },
  { month: 2, digite: 0 },
  { month: 3, digite: null },
  { month: 4, digite: 1 },
  { month: 5, digite: 2 },
  { month: 6, digite: 3 },
  { month: 7, digite: 4 },
  { month: 8, digite: 5 },
  { month: 9, digite: 6 },
  { month: 10, digite: 7 },
  { month: 11, digite: 8 },
  { month: 12, digite: null },
];

export { LogoLight, LogoDark, Menuitems, nameApp, urlEndPoint, DateRevision };
